"use client"

import ClickableLink from "../utilities/ClickableLink";
import {Suspense, use} from "react";
import moment from "moment/moment";
import {IFallbackData} from "../../utils/SchoolBlocksUtilities";
import styles from "./styles/RightColumnWidget.module.scss"
import classNames from "classnames";
import ImageComponent from "../utilities/ImageComponent";
import NewsImage from "../../assets/images/news.png";
import {withLocaleInURI} from "../../internationalization/i18nURI";
import {useStores} from "../../stores/useStores";
import {SchoolFeedMobileWidgetLink} from "./SchoolFeedMobileWidgetLink";
import {useSchoolFeedUrlQuery} from "../../hooks/useSchoolFeedData";

function useNewsUrl() {
    const {i18nStore} = useStores();
    const urlQuery = useSchoolFeedUrlQuery()

    return {
        pathname: withLocaleInURI("/feed", i18nStore.currentAppSupportedLocale),
        query: {...urlQuery, type: "news", currentView: "content"}
    }
}

export function MobileNewsWidgetLink(props: {
    active: boolean;
}) {
    const href = useNewsUrl();

    return <SchoolFeedMobileWidgetLink
        href={href}
        active={props.active}
        src={NewsImage}
        text={"News"}
    />
}

export const LoadingWidget = <div className={styles.loadingContainer}>
    <div/>
</div>

function NewsCountText(props: {
    initialNewsPromise: Promise<IFallbackData>
}) {
    const initialNews = use(props.initialNewsPromise);

    const recentNews = initialNews.contentItems.filter(item => {
        return moment(item.created_at).isAfter(moment().subtract(1, "month"))
    })

    return <div>Explore {recentNews.length > 0 ? recentNews.length + " " : ""}recent news posts and join the discussion!</div>
}

export function NewsWidget(props: {
    initialNewsPromise: Promise<IFallbackData>
}) {
    const href = useNewsUrl();

    return <ClickableLink href={href} className={classNames(styles.upcomingNews, styles.widget)}>
        <ImageComponent src={NewsImage}/>
        <Suspense fallback={LoadingWidget}>
            <NewsCountText initialNewsPromise={props.initialNewsPromise}/>
        </Suspense>
    </ClickableLink>
}